import mutations from "./documents-mutations";
import state from "./documents-state";
import actions from "./documents-actions";
import getters from "./documents-getters";
const documentsStore = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
export default documentsStore;